import COMPONENT_MAP from '../Repository/Components.js';

const DeliveryPricingRuleCityPopup=({popupCallBack,rowId,parent,userData,application})=>{
    const pageCallback=async(action,args)=>{
        popupCallBack(action,args);
    }

    const renderPageDetail=()=>{
        const Component=COMPONENT_MAP['PageDetail'];
        return Component?(
            <Component
                recordId={rowId}
                userData={userData}
                application={application}
                entityType={'DeliveryPricingCity'}
                entityParams={[
                    '_context='+[
                        'parent_field_name='+parent.parent_field_name,
                        'parent_field_value='+parent.parent_field_value,
                        'parent_name='+parent.parent_name,
                    ].join(","),
                    '_lang=' + application.globalData.lang,
                ]}
                file={'DeliveryPricingRuleCityPopup.js'}
                titleLabel={application.getLocale("FieldCity")}
                pageCallback={pageCallback}
                pageTabs={[]}
                isPopUp={true}
                openOnUpdate={true}
            />
        ):null; 
    };
    return (renderPageDetail());
}

export default DeliveryPricingRuleCityPopup;
